import { brandColors } from '@src/assets/colors/brandColors';
import SvgToggleOff from '@src/assets/images/common/icon/toggle-switch/SvgToggleOff';
import SvgToggleOn from '@src/assets/images/common/icon/toggle-switch/SvgToggleOn';
import { FC } from 'react';

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

const ToggleSwitch: FC<Props> = ({ checked, onChange }) => (
  <button
    type='button'
    onClick={() => onChange(!checked)}
    className='pt-[2px]'
  >
    {checked ? (
      <SvgToggleOn
        color={brandColors['500']}
        style={{
          width: '34px',
          height: '19px',
        }}
      />
    ) : (
      <SvgToggleOff
        color='black'
        style={{
          width: '34px',
          height: '19px',
        }}
      />
    )}
  </button>
);

export default ToggleSwitch;
